import { Controller } from '@hotwired/stimulus'
import { Offcanvas } from 'bootstrap'

// Reusable Stimulus controller for Bootstrap offcanvas
//
// Basic usage:
// <div class="offcanvas offcanvas-end" data-controller="offcanvas">
//   <div class="offcanvas-header">
//     <h5 class="offcanvas-title">Offcanvas Title</h5>
//     <button type="button" class="btn-close" data-action="click->offcanvas#hide"></button>
//   </div>
//   <div class="offcanvas-body">
//     <p>Offcanvas content here...</p>
//   </div>
// </div>
//
// Available data attributes:
// - data-offcanvas-show-value="true"           # Auto-show offcanvas on page load
// - data-offcanvas-backdrop-value="static"    # Prevent closing on backdrop click
// - data-offcanvas-keyboard-value="false"     # Disable ESC key closing
// - data-offcanvas-scroll-value="true"        # Allow body scrolling
//
// Available actions (call from other controllers):
// - data-action="click->offcanvas#show"       # Show offcanvas
// - data-action="click->offcanvas#hide"       # Hide offcanvas
// - data-action="click->offcanvas#toggle"     # Toggle offcanvas visibility
//
// Example with custom button trigger:
// <button data-action="click->offcanvas#toggle" data-offcanvas-target="navbarNav">
//   Toggle Navigation
// </button>

export default class extends Controller {
  static targets = ['offcanvas']
  static values = {
    show: { type: Boolean, default: false },
    backdrop: { type: String, default: 'true' },
    keyboard: { type: Boolean, default: true },
    scroll: { type: Boolean, default: false },
  }

  connect() {
    this.#closeOnBack()
    this.offcanvas = new Offcanvas(this.offcanvasTarget, {
      backdrop: this.backdropValue,
      keyboard: this.keyboardValue,
      scroll: this.scrollValue,
    })

    if (this.showValue) {
      this.show()
    }
  }

  disconnect() {
    if (this.offcanvas) {
      this.offcanvas.dispose()
    }
  }

  show() {
    this.offcanvas.show()
  }

  hide() {
    this.offcanvas.hide()
  }

  toggle() {
    this.offcanvas.toggle()
  }

  #closeOnBack() {
    // Force close if offcanvas is already shown from browser cache
    if (this.offcanvasTarget.classList.contains('show')) {
      this.offcanvasTarget.classList.remove('show')
      document.body.classList.remove('offcanvas-open')
      // Remove backdrop if it exists
      const backdrop = document.querySelector('.offcanvas-backdrop')
      if (backdrop) {
        backdrop.remove()
      }
    }
  }
}
